<template>
    <div>
        <div class="content-heading">
            <i class="ic-head-icon">
                <img src="@/assets/images/sidebar/s-wallet.svg" alt="Wallet Icon">
            </i>
            <h4 class="head-title">RUSH Wallet</h4>
            <i 
              class="ic-tooltip"
              v-b-popover.hover="'RUSH-powered feature that allows the CMS user to create, edit and freeze eWallets.'">
            </i>
            <WalletNav></WalletNav>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import WalletNav from "./WalletNav.vue";
export default {
    components: {
        WalletNav
    }
};
</script>

<style lang="scss" scoped>
</style>
